import React from 'react';
import ResourceCard from './ResourceCard';

interface Resource {
  id: string;
  title: string;
  description: string;
  type: string;
  formats: string[];
}

interface ResourceGridProps {
  resources: Resource[];
  onDownload: (resourceId: string) => void;
}

const ResourceGrid: React.FC<ResourceGridProps> = ({ resources, onDownload }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {resources.map(resource => (
        <ResourceCard
          key={resource.id}
          {...resource}
          onDownload={() => onDownload(resource.id)}
        />
      ))}
    </div>
  );
};

export default ResourceGrid;